function CancelIcon() {
    return (
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.08203 15.8301L5.01953 14.7676L8.95703 10.8301L5.01953 6.89258L6.08203 5.83008L10.0195 9.76758L13.957 5.83008L15.0195 6.89258L11.082 10.8301L15.0195 14.7676L13.957 15.8301L10.0195 11.8926L6.08203 15.8301Z" fill="#FCFCFC" />
        </svg>
    );
}

export default CancelIcon;
